import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/wb_sunny.svg'

const WbSunny: React.VFC<SvgIconProps> = props => <SvgIcon component={Icon} fill="currentColor" viewBox="0 0 16 16" {...props} />
export default WbSunny
